import React from "react";
import { RouteComponentProps, Route, RouteProps } from "react-router";
import ProtectedContent, { ErrorHandling } from "./ProtectedContent";
import { Role } from "../../Common/Constants/roleEnums";

type Props = RouteProps & { roles?: Role[] };

const ProtectedRoute: React.FC<Props> = props => {
  const { render, children, component, roles, ...routeProps } = props;

  // Try to allow for as many normal ways of rendering a route
  let contentRender: (routeProps: RouteComponentProps) => React.ReactNode;

  if (render) contentRender = contentRenderProps => render(contentRenderProps);
  // else if (component) contentRender =  () => component
  else if (children) contentRender = () => <>children</>;

  // var newProps : RouteProps = {
  //   location: routeProps.location,
  //   exact: routeProps.exact,
  //   path: routeProps.path,
  //   render: render
  // }

  if (component) {
    const Component = component;

    return (
      <Route
        {...routeProps}
        render={renderProps => (
          <ProtectedContent errorHandling={ErrorHandling.RedirectToAuth} roles={roles}>
            <Component
              history={renderProps.history}
              location={renderProps.location}
              match={renderProps.match}
            />
          </ProtectedContent>
        )}
      />
    );
  }
  return (
    <Route
      {...routeProps}
      render={renderProps => (
        <ProtectedContent errorHandling={ErrorHandling.RedirectToAuth} roles={roles}>
          {contentRender(renderProps)}
        </ProtectedContent>
      )}
    />
  );
};

export default ProtectedRoute;
